import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import AdminLayout from "../../../components/AdminLayout/AdminLayout.js";

function AddHaribhakt() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [surName, setSurname] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [street, setStreet] = useState("");
  const [address, setAddress] = useState("");
  const [mobileNumbers, setMobileNumbers] = useState([""]);
  const [email, setEmail] = useState("");
  const [birthDate, setBirthdate] = useState("");
  const [dharmadaId, setDharmadaId] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isVisible] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location?.pathname || "";
  const { id } = location?.state || {};

  console.log(`id: ${id}`);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  const addMobileField = () => {
    if (mobileNumbers.length < 3) {
      setMobileNumbers([...mobileNumbers, ""]);
    }
  };

  const removeMobileField = (index) => {
    if (mobileNumbers.length > 1) {
      setMobileNumbers(mobileNumbers.filter((_, i) => i !== index));
    }
  };

  const handleMobileChange = (index, value) => {
    // Allow only numbers and limit to 10 digits
    if (/^\d{0,10}$/.test(value)) {
      const updatedMobiles = [...mobileNumbers];
      updatedMobiles[index] = value;
      setMobileNumbers(updatedMobiles);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));

      const fileLabel = document.getElementById("photoUpload");
      if (fileLabel) fileLabel.innerText = file.name; // Check if element exists
    } else {
      toast.error("Please select a valid image file (jpg, png, etc.)");
      setImage(null);
      setImagePreview(null);

      const fileLabel = document.getElementById("photoUpload");
      if (fileLabel) fileLabel.innerText = "Choose file"; // Check if element exists
    }
  };

  const handleSubmit = (e) => {
    setLoaded(true);
    e.preventDefault();

    let data = new FormData();
    data.append("mandalDetailsId", id);
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    data.append("surName", surName);
    data.append("userName", userName);
    data.append("password", password);
    data.append("houseNo", houseNo);
    data.append("street", street);
    data.append("Address", address || "");
    data.append("contactNo", mobileNumbers[0]);
    data.append("contactNo1", mobileNumbers[1] || "");
    data.append("contactNo2", mobileNumbers[2] || "");
    data.append("emailId", email || "");
    data.append("birthDate", birthDate || "");
    data.append("dharmadaId", dharmadaId);
    data.append("isVisible", isVisible);
    data.append("type", "HariBhakt");
    data.append("AttendenceStatus", false);
    if (image) {
      data.append("Image", image);
    }

    let config = {
      method: "post",
      url: `${apiURL}/User/Create`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoaded(false);
        setFirstName("");
        setLastName("");
        setSurname("");
        setUserName("");
        setPassword("");
        setHouseNo("");
        setStreet("");
        setAddress("");
        setMobileNumbers([""]);
        setEmail("");
        setBirthdate("");
        setDharmadaId("");
        setImage(null);
        setImagePreview(null);

        const fileInput = document.getElementById("photoUpload");
        if (fileInput) {
          fileInput.value = "";
          const label = fileInput.nextElementSibling;

          if (label) {
            label.innerText = "Choose file (417 X 530 - 1MB)";
          }
        }
        toast.success(response.data.message);

        if (currentPath === "/add-haribhakt1") {
          const timeOutId = setTimeout(() => {
            if (currentPath === "/add-haribhakt1") {
              navigate("/manage-haribhakt1", { state: { id: id } });
            }
          }, 3000);
          return () => clearTimeout(timeOutId);
        }
      })
      .catch((error) => {
        setLoaded(false);
        toast.error(error.response?.data?.message);
      });
  };

  return (
    <AdminLayout ac8="active" id={id}>
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Add Haribhakt</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/manage-mandal1" state={{ id: id }}>
                    Mandal List
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/mandal-info1" state={{ id: id }}>
                    Mandal Information
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/manage-haribhakt1" state={{ id: id }}>
                    Haribhakt List
                  </Link>
                </li>
                <li className="breadcrumb-item">Add Haribhakt</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktFirstname">First Name</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktLastname">Middle Name</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Middle Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktSurname">Surname</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Surname"
                        value={surName}
                        onChange={(e) => setSurname(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktUsername">Username</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktPassword">Password</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="haribhaktImage">Upload Image</label>
                    <div className="input-group mb-3">
                      <div className="form-control d-flex align-items-center justify-content-center">
                        <label
                          className="w-100 text-muted"
                          style={{ cursor: "pointer" }}
                        >
                          {image ? image.name : "Upload Profile Photo"}
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            hidden
                          />
                        </label>
                      </div>
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-camera"></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    {imagePreview && (
                      <div>
                        <label className="mr-3">Preview: </label>
                        <img
                          src={imagePreview}
                          alt="Selected file preview"
                          className="img-preview"
                        />
                      </div>
                    )}
                  </div>
                </div>
                {/* Mobile Number Fields */}
                <label htmlFor="haribhaktMobileNumber">Mobile Number</label>
                {mobileNumbers.map((number, index) => (
                  <div className="input-group mb-3" key={index}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Mobile Number ${index + 1}`}
                      value={number}
                      onChange={(e) =>
                        handleMobileChange(index, e.target.value)
                      }
                      required
                      pattern="\d{10}"
                      title="Enter a valid 10-digit mobile number"
                    />

                    <div className="input-group-append">
                      <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center justify-content-center"
                        onClick={addMobileField}
                        disabled={mobileNumbers.length >= 3}
                        style={{ width: "40px" }}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                      {mobileNumbers.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger d-flex align-items-center justify-content-center"
                          onClick={() => removeMobileField(index)}
                          style={{ width: "40px" }}
                        >
                          <i className="fas fa-minus"></i>
                        </button>
                      )}
                    </div>
                  </div>
                ))}

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktHouseNo">House No.</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="House No."
                        value={houseNo}
                        onChange={(e) => setHouseNo(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktStreet">Street</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Street"
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktAddress">Address</label>
                      <input
                        className="form-control"
                        placeholder="Enter Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktEmail">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktBirthdate">Birthdate</label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Birthdate"
                        value={birthDate}
                        onChange={(e) => setBirthdate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktDharmadaId">Dharmada Id</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Dharmada Id"
                        value={dharmadaId}
                        onChange={(e) => setDharmadaId(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </AdminLayout>
  );
}

export default AddHaribhakt;
